import styled from 'styled-components'
import tokens from '@gympass/yoga-tokens'
import { Row, Container as YogaContainer, Button, Text } from '@gympass/yoga'

import getBreakpoint from '@client/utils/breakpoints'

import Image from '@components/Image'

export const Container = styled(YogaContainer)`
  @media (min-width: ${getBreakpoint('md')}px) and (max-width: ${getBreakpoint(
      'lg'
    )}px) {
    max-width: 344px;
    margin: 0 auto;
  }
`

export const WrapperTitle = styled(Row)`
  padding-top: 50px;
`

export const Header = styled.header`
  background-color: #f5f5fa;
`

export const CheckIcon = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 54px;
  height: 54px;
  border: 2px solid ${tokens.colors.stamina};
  border-radius: 100%;
  margin-top: 64px;

  img {
    height: 20px;
  }

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    margin-top: 96px;
  }
`

export const Title = styled.h1`
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 38px;
`

export const Subtitle = styled.h2`
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 19px;
  margin: 0;

  strong {
    margin-left: 4px;
  }
`

export const IllustrationWrapper = styled.section`
  margin: 96px auto 0;
  width: 120px;
`

export const Payment = styled.section`
  background-color: #ffffff;

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    padding-top: 32px;
  }
`

export const NextSteps = styled.section`
  background-color: #ffffff;

  ${Subtitle} {
    margin-top: 8px;
  }

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    padding-top: 56px;
  }
`

export const NextStepItem = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
  margin-bottom: 48px;

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    flex-direction: row;
    margin-top: 0;
  }
`

export const NextStepContent = styled.section`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${Button.Outline} {
    margin-top: 24px;

    @media (min-width: ${tokens.breakpoints.xl.width}px) {
      width: auto;
    }
  }

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    margin-left: 32px;
    margin-top: 52px;
    margin-bottom: 64px;
  }
`

export const NextStepIcon = styled(Image)`
  align-self: center;
  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    align-self: flex-start;
    margin-top: 52px;
  }
`

export const NextStepTitle = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  margin: 0 0 8px;
`

export const Heading = styled.h2`
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  margin: 64px 0 0;
`

export const Body1 = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  margin: 0 0 10px 0;
  color: ${tokens.colors.deep};
`

export const FooterWrapper = styled.section`
  padding-top: 20px;
  padding-bottom: 20px;
  background-color: #f5f5fa;

  @media (min-width: ${tokens.breakpoints.md.width}px) {
    padding: 32px 12px;
  }

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    padding: 32px 0;
  }
`

export const FooterContent = styled.section`
  display: flex;
  align-items: center;
  flex-direction: column;

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    flex-direction: row;
    justify-content: space-between;
  }
`

export const LogoWrapper = styled.section`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 20px;

  img {
    margin-bottom: 8px;
  }

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    align-items: flex-start;
    margin: 0;
  }
`

export const TextTiny = styled(Text.Tiny)`
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 18px;
  margin-top: 32px;
  margin-bottom: 12px;
  color: #9898a7;

  @media (min-width: ${tokens.breakpoints.xl.width}px) {
    font-size: 12px;
    margin: 0;
    padding: 0;
  }
`

export const PaymentDescriptionWrapper = styled.section`
  margin-top: 24px;

  ${Body1}:last-of-type {
    margin-top: 24px;
  }
`
